import React from 'react';
import PropTypes from 'prop-types';
import compose from 'react-recompose/compose';
import getContext from 'react-recompose/getContext';
import Color from 'color';

import { isDark } from '../icon/icon';

import styles from './styles.less';

const PUBLIC_URL = process.env.PUBLIC_URL;
const logoImage = `${PUBLIC_URL}/img/logo_white_horiz.png`;


function clamp(v, mn, mx) {
    return Math.max(Math.min(v, mx), mn);
}


const mtStyle = {};


class Logo extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {}
    }

    stopEventPropagation(e) {
        e.stopPropagation();
    }

    
    // -> div | null
    graphistryLogo({invert, hasUserLogo, dataset}) {
        const gLogoStyle = invert ? {filter: invert} : mtStyle;
        const tier = this.tier({dataset});
        const gLogo =
            (<div style={ gLogoStyle } className={styles['graphistry-logo']}>
                { hasUserLogo
                    ? <div className={styles['graphistry-built-by']}>shown with</div>
                    : null }
                <img draggable="false" src={logoImage} />
                { tier }
                { hasUserLogo
                    ? null
                    : <div className={styles['logo-version']}>{ process.env.APP_BUILD_TAG }</div> }
            </div>);
        return gLogo;
    }

    tier({dataset}) {
        const { entitlements } = dataset || {};
        const { paid } = entitlements || {};
        console.debug({paid, dataset}, '@Logo.render::tier');
        if (paid === 'unknown' || paid === undefined) {
            return null;
        }
        if (paid === true) {
            return true;
        }
        if (paid === false) {
            return (
                <a 
                    className={`${styles['graphistry-tier']} ${styles['free-tier']}`}
                    href="https://www.graphistry.com/get-started"
                    target="_blank"
                ><i className={`fa fa-wrench ${styles['free-icon']}`}></i> FREE TIER</a>);
        }
        return null;
    }
    
    userLogo({invert}) {

        const { logoContainer = {} } = this.props || {};
        const { url, dimensions, padding, crop, autoInvert = false, style } = logoContainer;

        if (!url) {
            return null;
        }

        const styleProps = {};
        
        //////////////////////// STYLE PROPS ////////////////////////

        if (dimensions) {
            if (+dimensions.maxWidth) {
                styleProps['maxWidth'] =  clamp(dimensions.maxWidth, 0, 300);
            }
            if (+dimensions.maxHeight) {
                styleProps['maxHeight'] = clamp(dimensions.maxHeight, 0, 300);
            }
        }

        if (padding) {
            if (+padding.top) {
                styleProps['paddingTop'] = clamp(padding.top, 0, 200);
            }
            if (+padding.left) {
                styleProps['paddingLeft'] = clamp(padding.left, 0, 200);
            }
            if (+padding.bottom) {
                styleProps['paddingBottom'] = clamp(padding.bottom, 0, 200);
            }
            if (+padding.right) {
                styleProps['paddingRight'] = clamp(padding.right, 0, 200);
            }
        }

        /*
        if (crop && dimensions && +dimensions.maxWidth && +dimensions.maxHeight) {
            const clipRect = {
                top: +crop.top || 0,
                bottom: dimensions.maxHeight - crop.bottom,
                left: +crop.left || 0,
                right: dimensions.maxWidth - crop.left
            };
            styleProps['clip'] = `rect(${clipRect.top}px, ${clipRect.right}px, ${clipRect.bottom}px, ${clipRect.left}px)`;
            styleProps['position'] = 'absolute';
            styleProps['top'] = `${-clipRect.top}px`;
            styleProps['left'] = `${-clipRect.left}px`;
        }
        */

        //TODO crop: https://www.xul.fr/en/css/clip.php

        if ((autoInvert && invert) || style) {
            const filters = {};
            if (autoInvert && invert) {
                filters.invert = invert;
            }
            if (style) {
                ['opacity', 'grayscale', 'brightness', 'contrast', 'invert', 'saturate'].forEach(p => {
                    if (p in style) {
                        const v = +(style[p]);
                        if (!isNaN(v)) {
                            filters[p] = `${p}(${clamp(v, 0, 1)})`;
                        }
                    }
                });
                if ('hueRotate' in style) {
                    const v = +(style['hueRotate']);
                    if (!isNaN(v)) {
                        filters['hueRotate'] = `hue-rotate(${clamp(Math.round(v), 0, 360)}deg)`;
                    }
                }
            }
            const filterStr = Object.values(filters).join(' ');
            if (filterStr) {
                styleProps.filter = filterStr;
            }
        }

        //////////////////////// STYLE PROPS ////////////////////////

        const userLogo = (
            <div className={styles['user-logo']}>
                <img
                    src={url}
                    style={Object.keys(styleProps).length ? styleProps : mtStyle}
                />
            </div>);
        
        return userLogo;
    }
    
    //change on bg color change b/c luminosity
    render() {

        const { logoContainer = {}, showLogo = true, backgroundColor = '#000000', dataset } = this.props;

        console.debug({dataset}, '@Logo::render');

        if (!showLogo) {
            return null;
        }

        //assuming logo is light, a dark bg requires no invert, while a light be requires 50%+ 
        const colorRGB = new Color(backgroundColor).rgb();
        const invert = isDark( colorRGB.object() ) ? '' : `invert(0.9)`;

        let { position = 'bottom' } = logoContainer;
        if (!['top', 'bottom'].find((v) => v == position)) {
            position = 'bottom';
        }

        const userLogo = this.userLogo({invert});
        const gLogo = this.graphistryLogo({invert, hasUserLogo: !!userLogo, dataset});

        return (
            <div>
                <div 
                    className={`
                        ${styles['logo-container']}
                        ${styles[`logo-${position}`]}
                        ${styles[`logo-with-user-${userLogo ? 'on' : 'off'}`]}
                    `}>
                    <div className={styles['logo-stack']}>
                        { userLogo ? userLogo : undefined }
                        { gLogo }
                    </div>
                </div>
            </div>);
    }
}

const LogoWrapped = compose(
    getContext({
        showLogo: PropTypes.bool,
    })
)(Logo);

export { LogoWrapped as Logo };
